import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-case-declarations */

/* eslint-disable prefer-destructuring */

/* eslint-disable consistent-return */
import React, { createContext, useReducer, useMemo, useContext, useEffect, useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment-timezone';
import { getAvailableMilestones, buildComputedMilestonesResForHopeReopen, visitHasHopeDoc, getCurrentMilestone, getHopeSIADTO, refusedSIAOptions, emptySIA, acceptedHopeAttributes, getHopeFormInfo, visitHasHopeAttribute, resolveHopeVisitDecisionForReopen, HopeADMFormKeys, HopeHUVFormKeys } from '@mummssoftware/utils';
import { isAgencyEnabled } from '@mummssoftware/utils/utils';
import { ADM, Admit, hopeDocumentProps, getHopePreSubmitMilestoneType, getHopeBlockingErrors, hopePatientSiaExists, extractSIADataFromHopePatientSia, isSIADataComplete, buildHopeSIANoteText, buildHopePatientDetailPayload, siaRequiresSfv } from '@mummssoftware/utils/hope';
import { getVisitByVisitId, getVisitByPersonAndVisitId } from '@mummssoftware/utils/pimReader';
import { InProgress } from '@mummssoftware/utils/constants';
import { siteLocalToMoment, utcToSiteMoment } from '@mummssoftware/utils/dates';
import { formatPostDate } from '@mummssoftware/utils/formatters';
import { Nurse } from '@mummssoftware/utils/roleData';
import { SET_APP_VISIT_DETAILS } from '../GlobalContext/constants';
import { SET_CROSS_PATIENT_HIS, SET_CROSS_PATIENT_HOPE, SET_AVAILABLE_ACTIONS, SET_AVAILABLE_MILESTONES_RES, SET_CAN_SUBMIT_HOPE_VISIT, SET_IS_HOPE_VISIT, UPDATE_SIA_DATA, SET_VISIT_REQUIRES_SFV, SET_SIA_DISPLAY, SET_SIA_TEXT, SET_HOPE_DETAIL, SET_NON_USER_IN_PROG_HOPE_VISIT, SET_HOPE_VISIT_ATTRIBUTES_SAVED, SET_HOPE_MILESTONE_STATE, SET_HOPE_VISIT_PROMPT_DISPLAY, SET_HOPE_MISSING_DOCUMENTATION, SET_HOPE_MISSING_SIA, SET_HOPE_VALIDATION_PENDING } from './constants';
import { GlobalContext } from '../GlobalContext';
import { PNGlobalContext, REFRESH_PN_DATA } from '../PNGlobalContext';
import { VisitsGlobalContext } from '../VisitsGlobalContext';

const initFunc = props => null;

const initHopeRecordVisitSequence = async () => ({
  proceed: true
});

const initialState = {
  globalCrossPatientHopeData: null,
  patientHopeDetail: null,
  globalCrossPatientHIS: null,
  availableHOPEActions: null,
  availableMilestonesRes: null,
  isHopeVisit: null,
  isOtherInProgHopeVisit: null,
  canSubmitHopeVisit: true,
  SIAData: {},
  postSIAData: initFunc,
  refuseSIAVisit: initFunc,
  resetHopeWorkflow: initFunc,
  refreshHopeData: initFunc,
  updateHopeVisitStatus: initFunc,
  admitHopePatient: initFunc,
  visitRequiresSFV: false,
  SIAText: null,
  displaySIA: false,
  hopeVisitAttributesSaved: false,
  displayHopeVisitPrompt: false,
  hopeMissingDocumentation: false,
  hopeMissingSIA: false,
  hopeValidationPending: false,
  dispatch: null
};
const initHopeGlobalContext = {
  globalCrossPatientHopeData: null,
  patientHopeDetail: null,
  globalCrossPatientHIS: null,
  availableHOPEActions: null,
  availableMilestonesRes: null,
  isHopeVisit: null,
  isOtherInProgHopeVisit: null,
  canSubmitHopeVisit: true,
  SIAData: {},
  postSIAData: initFunc,
  refuseSIAVisit: initFunc,
  resetHopeWorkflow: initFunc,
  refreshHopeData: initFunc,
  updateHopeVisitStatus: initFunc,
  admitHopePatient: initFunc,
  visitRequiresSFV: false,
  SIAText: null,
  displaySIA: false,
  hopeVisitAttributesSaved: false,
  displayHopeVisitPrompt: false,
  hopeMissingDocumentation: false,
  hopeMissingSIA: false,
  hopeValidationPending: false,
  getAllUsersHopeMilestones: initFunc,
  runHopeRecordVisitSequence: initHopeRecordVisitSequence,
  saveHopePatientSIAForVisit: async () => false,
  postHopeSIANote: async () => false,
  dispatch: null
};
export const HopeGlobalContextReducer = (state, action) => {
  let newState = _objectSpread({}, state);

  switch (action.type) {
    case SET_HOPE_DETAIL:
      newState.patientHopeDetail = action.payload;
      break;

    case SET_CROSS_PATIENT_HIS:
      newState.globalCrossPatientHIS = action.payload;
      break;

    case SET_CROSS_PATIENT_HOPE:
      newState.globalCrossPatientHopeData = action.payload;
      break;

    case SET_AVAILABLE_ACTIONS:
      newState.availableHOPEActions = action.payload;
      break;

    case SET_AVAILABLE_MILESTONES_RES:
      newState.availableMilestonesRes = action.payload;
      break;

    case SET_HOPE_MILESTONE_STATE:
      {
        const {
          availableMilestones,
          computedMilestonesRes,
          isHopeVisit: hopeVisitFlag,
          displayHopeVisitPrompt
        } = action.payload;
        newState.availableHOPEActions = availableMilestones;
        newState.availableMilestonesRes = computedMilestonesRes;

        if (state.isHopeVisit !== hopeVisitFlag) {
          newState.isHopeVisit = hopeVisitFlag; // eslint-disable-next-line no-unneeded-ternary

          newState.canSubmitHopeVisit = hopeVisitFlag === true ? false : true;
        } // Visit already has accepted/refused HOPE attrs from PIM (remount/reopen):
        // treat them as saved so SIA checkbox / submit are not blocked waiting for
        // persistHopeVisitAttributes (which only runs on the initial accept flow).


        if (hopeVisitFlag !== null) {
          newState.hopeVisitAttributesSaved = true;
        }

        newState.displayHopeVisitPrompt = !!displayHopeVisitPrompt;
        break;
      }

    case SET_HOPE_VISIT_PROMPT_DISPLAY:
      newState.displayHopeVisitPrompt = !!action.payload;
      break;

    case SET_CAN_SUBMIT_HOPE_VISIT:
      newState.canSubmitHopeVisit = action.payload;
      break;

    case SET_IS_HOPE_VISIT:
      if (state.isHopeVisit !== action.payload) {
        newState.isHopeVisit = action.payload; // Block submit until SIA is validated when this becomes a HOPE visit; allow submit when not
        // eslint-disable-next-line no-unneeded-ternary

        newState.canSubmitHopeVisit = action.payload === true ? false : true;
      }

      newState.hopeVisitAttributesSaved = false;
      newState.displayHopeVisitPrompt = false;
      newState.hopeMissingDocumentation = false;
      newState.hopeMissingSIA = false;
      newState.hopeValidationPending = action.payload === true;
      break;

    case SET_HOPE_VISIT_ATTRIBUTES_SAVED:
      newState.hopeVisitAttributesSaved = action.payload;
      break;

    case SET_VISIT_REQUIRES_SFV:
      newState.visitRequiresSFV = action.payload;
      break;

    case SET_SIA_TEXT:
      newState.SIAText = action.payload;
      break;

    case UPDATE_SIA_DATA:
      newState.SIAData = _objectSpread({}, action.payload);
      break;

    case SET_SIA_DISPLAY:
      newState.displaySIA = action.payload;
      break;

    case SET_NON_USER_IN_PROG_HOPE_VISIT:
      newState.isOtherInProgHopeVisit = action.payload;
      break;

    case SET_HOPE_MISSING_DOCUMENTATION:
      newState.hopeMissingDocumentation = action.payload;
      break;

    case SET_HOPE_MISSING_SIA:
      newState.hopeMissingSIA = action.payload;
      break;

    case SET_HOPE_VALIDATION_PENDING:
      newState.hopeValidationPending = action.payload;
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const HopeGlobalContext = /*#__PURE__*/createContext(initHopeGlobalContext);
export const HopeGlobalDispatchContext = /*#__PURE__*/createContext({});
export const HopeGlobalContextConsumer = HopeGlobalContext.Consumer;
export const HopeGlobalDispatchContextConsumer = HopeGlobalDispatchContext.Consumer;

/** DIS + backdated visit: use milestones from the HOPE detail row whose day-of-service matches this visit. */
function mergeDischargeBackdateMilestones(hopeStatus, computed, patient, appVisit, patientHopeDetail) {
  const visitDay = appVisit === null || appVisit === void 0 ? void 0 : appVisit.effectivedatetime; // need to check for DIS status in case they are back-dating the visit
  // add condition if todays date is after the visit date
  // make the day of today is after the visit date
  // API shape uses dischargedata.milestone (mumms types list dischargedata as array only).

  const dischargedata = hopeStatus.dischargedata;

  if (patient && patient.dischargeDate && visitDay && moment(patient.dischargeDate).isSameOrAfter(moment(visitDay), 'day') && !computed.milestone.length && // add visit date is before discharge date
  (dischargedata === null || dischargedata === void 0 ? void 0 : dischargedata.milestone) === 'DIS' && moment().isAfter(moment(visitDay), 'day') && hopeStatus.admissiondate_shifted) {
    var _patientHopeDetail$fi;

    // need to find the corresponding milestone for the visit date and set the computedMilestonesRes
    // dos day of service, the number od days between admission and visit date
    const dos = moment(visitDay).startOf('day').diff(moment(hopeStatus.admissiondate_shifted).startOf('day'), 'days'); // need to find the corresponding milestone for the dos
    // look through the patientHopeDetail and find the milestone that has the same dos

    const detailForDos = (_patientHopeDetail$fi = patientHopeDetail === null || patientHopeDetail === void 0 ? void 0 : patientHopeDetail.find(row => row.dayofservice === dos)) !== null && _patientHopeDetail$fi !== void 0 ? _patientHopeDetail$fi : patientHopeDetail === null || patientHopeDetail === void 0 ? void 0 : patientHopeDetail.find(row => row.dayofservice > dos);

    if (detailForDos) {
      const recomputed = getAvailableMilestones(detailForDos, appVisit);
      const hopeKey = recomputed.key;

      if (hopeKey) {
        const milestoneSlice = hopeStatus[hopeKey];
        const lastStatus = milestoneSlice === null || milestoneSlice === void 0 ? void 0 : milestoneSlice.status;

        if (!lastStatus) {
          return recomputed;
        }
      }
    }
  }

  return computed;
}

export const HopeGlobalContextProvider = ({
  children,
  keycloak,
  workflow,
  observation,
  patient,
  agency,
  siteId,
  currentUser
}) => {
  const [{
    globalCrossPatientHopeData,
    patientHopeDetail,
    globalCrossPatientHIS,
    availableHOPEActions,
    availableMilestonesRes,
    isHopeVisit,
    canSubmitHopeVisit,
    SIAData,
    visitRequiresSFV,
    SIAText,
    displaySIA,
    displayHopeVisitPrompt,
    isOtherInProgHopeVisit,
    hopeVisitAttributesSaved,
    hopeMissingDocumentation,
    hopeMissingSIA,
    hopeValidationPending
  }, dispatch] = useReducer(HopeGlobalContextReducer, initialState);
  const {
    appVisit,
    appVisitDetails,
    completedPatientForms,
    inProgressPatientForms,
    dispatch: globalDispatch
  } = useContext(GlobalContext);
  const {
    patientVisitHistory,
    refreshVisits
  } = useContext(VisitsGlobalContext);
  const {
    dispatchPN: dispatchPNG
  } = useContext(PNGlobalContext);
  const siaFetchedForVisitIdRef = useRef(null);
  const hopeMilestonesLoadedVisitIdRef = useRef(null);
  const isHopeEnabled = !isAgencyEnabled(window.env.disableHopeVisitWorkflow, currentUser);

  const getVisitHopeStatus = async (hopeStatus, options) => {
    const reopenMilestoneKey = appVisit === null || appVisit === void 0 ? void 0 : appVisit.hopeReopenWorkflowMilestone;

    if (reopenMilestoneKey && typeof reopenMilestoneKey === 'string' && reopenMilestoneKey.length > 0 && appVisit) {
      const computedMilestonesRes = buildComputedMilestonesResForHopeReopen(hopeStatus, appVisit, reopenMilestoneKey);
      const availableMilestones = computedMilestonesRes.milestone;
      hopeMilestonesLoadedVisitIdRef.current = `${appVisit.id}`;
      dispatch({
        type: SET_HOPE_MILESTONE_STATE,
        payload: {
          availableMilestones,
          computedMilestonesRes,
          isHopeVisit: resolveHopeVisitDecisionForReopen(appVisit),
          displayHopeVisitPrompt: false
        }
      });
      return;
    }

    if (!hopeStatus) {
      return;
    }

    const computedMilestonesRes = mergeDischargeBackdateMilestones(hopeStatus, getAvailableMilestones(hopeStatus, appVisit), patient, appVisit, patientHopeDetail);
    const {
      milestone: availableMilestones,
      visitid: visitId,
      visitEligibleFrom
    } = computedMilestonesRes; // if not return

    const appVisitEffective = appVisit === null || appVisit === void 0 ? void 0 : appVisit.effectivedatetime;
    const siteTimezone = currentUser === null || currentUser === void 0 ? void 0 : currentUser.siteTimezone;

    if (!availableMilestones.length || !visitEligibleFrom || !appVisit || !appVisitEffective || !siteTimezone) {
      return;
    } // visitEligibleFrom is typed null from getAvailableMilestones seed; runtime value is a string


    const visitEligibleSiteDay = siteLocalToMoment(String(visitEligibleFrom), siteTimezone);
    const visitEffectiveSiteDay = utcToSiteMoment(appVisitEffective, siteTimezone);

    if (!visitEligibleSiteDay.isSameOrBefore(visitEffectiveSiteDay, 'day')) {
      return;
    }

    const allowAutoPrompt = (options === null || options === void 0 ? void 0 : options.allowAutoPrompt) !== false;

    const commitHopeMilestoneState = () => {
      const hopeVisitFlag = visitHasHopeAttribute(appVisit);
      const milestoneStatus = computedMilestonesRes.status || '';
      const shouldAutoPrompt = allowAutoPrompt && hopeVisitFlag === null && !isOtherInProgHopeVisit && !milestoneStatus.includes(InProgress) && !(appVisit !== null && appVisit !== void 0 && appVisit.hopeReopenWorkflowMilestone);
      hopeMilestonesLoadedVisitIdRef.current = `${appVisit.id}`;
      dispatch({
        type: SET_HOPE_MILESTONE_STATE,
        payload: {
          availableMilestones,
          computedMilestonesRes,
          isHopeVisit: hopeVisitFlag,
          displayHopeVisitPrompt: shouldAutoPrompt
        }
      });
    }; // iff visitId means a hope visit is already in progress or happened for that milestone


    if (visitId && agency) {
      const hopeVisit = await getVisitByVisitId(String(visitId), String(agency), keycloak);

      if (hopeVisit instanceof Response) {
        return;
      }

      const hopeVisitRow = hopeVisit[0];

      if (!(hopeVisitRow !== null && hopeVisitRow !== void 0 && hopeVisitRow.effectivedatetime)) {
        return;
      }

      if (visitEffectiveSiteDay.isSameOrAfter(utcToSiteMoment(hopeVisitRow.effectivedatetime, siteTimezone), 'day')) {
        commitHopeMilestoneState();
      }

      return;
    } // you are the first to open a visit for that milestone


    commitHopeMilestoneState();
  };

  const getHopeMilestones = async () => {
    let hopeStatus;

    if (!!patientHopeDetail && patientHopeDetail.length && !!appVisit) {
      hopeStatus = patientHopeDetail[patientHopeDetail.length - 1];
    } else {
      var _patient$episodes;

      const hopeStatusRes = await workflow.getHopePatientStatus(`${patient === null || patient === void 0 ? void 0 : patient.id}` || '', `${((patient === null || patient === void 0 ? void 0 : (_patient$episodes = patient.episodes) === null || _patient$episodes === void 0 ? void 0 : _patient$episodes.length) || 1) - 1}`, agency || '', siteId || '');
      hopeStatus = !(hopeStatusRes instanceof Response) && hopeStatusRes.length ? hopeStatusRes[0] : null;
    }

    if (hopeStatus) {
      getVisitHopeStatus(hopeStatus);
    }
  };

  const getAllUsersHopeMilestones = useCallback(async () => {
    if (patient) {
      var _patient$episodes2;

      const hopeDetailData = await (workflow === null || workflow === void 0 ? void 0 : workflow.getHopePatientDetails(`${patient === null || patient === void 0 ? void 0 : patient.id}` || '', `${((patient === null || patient === void 0 ? void 0 : (_patient$episodes2 = patient.episodes) === null || _patient$episodes2 === void 0 ? void 0 : _patient$episodes2.length) || 1) - 1}`, agency || '', siteId || ''));

      if (!(hopeDetailData instanceof Response)) {
        const patientHopeDetailPayload = buildHopePatientDetailPayload(hopeDetailData);
        dispatch({
          type: SET_HOPE_DETAIL,
          payload: patientHopeDetailPayload
        });

        if (patientHopeDetailPayload && patientHopeDetailPayload.length && appVisit) {
          const hopeStatus = patientHopeDetailPayload[patientHopeDetailPayload.length - 1];

          if (hopeStatus) {
            getVisitHopeStatus(hopeStatus, {
              allowAutoPrompt: false
            });
          }
        }
      }
    }
  }, [workflow, patient, agency, siteId, appVisit, dispatch]);

  const validateVisitData = () => {
    const currentMilestone = getCurrentMilestone(availableHOPEActions);
    const validationPending = !isOtherInProgHopeVisit && !currentMilestone;
    let missingSIA = false;
    let missingDocumentation = false;

    if (!isOtherInProgHopeVisit && currentMilestone) {
      const currentMilestoneIsSFV = currentMilestone.includes('-SFV');
      const SIADataComplete = !!SIAData && Object.keys(SIAData).length === 8;
      const visitHasHopeDocumentation = appVisitDetails && visitHasHopeDoc(currentMilestone, appVisitDetails.formsdto);
      missingSIA = !SIADataComplete;
      missingDocumentation = !currentMilestoneIsSFV && !visitHasHopeDocumentation;

      if (SIADataComplete) {
        dispatch({
          type: SET_VISIT_REQUIRES_SFV,
          payload: siaRequiresSfv(SIAData, currentMilestone)
        });
      }
    }

    dispatch({
      type: SET_HOPE_VALIDATION_PENDING,
      payload: validationPending
    });
    dispatch({
      type: SET_HOPE_MISSING_SIA,
      payload: missingSIA
    });
    dispatch({
      type: SET_HOPE_MISSING_DOCUMENTATION,
      payload: missingDocumentation
    });
    const blockedByVisitSetup = !hopeVisitAttributesSaved || !!isOtherInProgHopeVisit;
    const blockedByHopeRequirements = validationPending || missingSIA || missingDocumentation;
    const submitAllowed = !blockedByVisitSetup && !blockedByHopeRequirements;
    dispatch({
      type: SET_CAN_SUBMIT_HOPE_VISIT,
      payload: submitAllowed
    });
  };

  const refreshHopeData = () => {
    dispatch({
      type: SET_HOPE_DETAIL,
      payload: null
    });
    dispatch({
      type: SET_CROSS_PATIENT_HOPE,
      payload: null
    });
  };

  const resetHopeWorkflow = () => {
    siaFetchedForVisitIdRef.current = null;
    hopeMilestonesLoadedVisitIdRef.current = null;
    ReactDOM.unstable_batchedUpdates(() => {
      dispatch({
        type: SET_IS_HOPE_VISIT,
        payload: null
      });
      dispatch({
        type: SET_AVAILABLE_ACTIONS,
        payload: null
      });
      dispatch({
        type: SET_AVAILABLE_MILESTONES_RES,
        payload: null
      });
      dispatch({
        type: SET_CAN_SUBMIT_HOPE_VISIT,
        payload: true
      });
      dispatch({
        type: UPDATE_SIA_DATA,
        payload: {}
      });
      dispatch({
        type: SET_VISIT_REQUIRES_SFV,
        payload: false
      });
      dispatch({
        type: SET_SIA_TEXT,
        payload: null
      });
      dispatch({
        type: SET_SIA_DISPLAY,
        payload: false
      });
      dispatch({
        type: SET_HOPE_VISIT_PROMPT_DISPLAY,
        payload: false
      });
      dispatch({
        type: SET_HOPE_VISIT_ATTRIBUTES_SAVED,
        payload: false
      });
      dispatch({
        type: SET_HOPE_MISSING_SIA,
        payload: false
      });
      dispatch({
        type: SET_HOPE_MISSING_DOCUMENTATION,
        payload: false
      });
      dispatch({
        type: SET_HOPE_VALIDATION_PENDING,
        payload: false
      });
    });
  };

  const getHopeFormInfoForVisit = currentMilestone => {
    const currentMilestoneIsSFV = currentMilestone === null || currentMilestone === void 0 ? void 0 : currentMilestone.includes('-SFV');

    if (!currentMilestoneIsSFV) {
      return undefined;
    }

    const formKeys = currentMilestone !== null && currentMilestone !== void 0 && currentMilestone.includes(ADM) ? HopeADMFormKeys : HopeHUVFormKeys;
    return getHopeFormInfo(currentMilestone, completedPatientForms, patientVisitHistory, formKeys);
  };

  const saveHopePatientSIAForVisit = useCallback(async (symptomData = SIAData, visitId) => {
    var _ref;

    if (!patient) return false;
    const resolvedVisitId = `${(_ref = visitId !== null && visitId !== void 0 ? visitId : appVisit === null || appVisit === void 0 ? void 0 : appVisit.id) !== null && _ref !== void 0 ? _ref : ''}`;
    if (!resolvedVisitId) return false;
    const currentMilestone = getCurrentMilestone(availableHOPEActions);
    const currentMilestoneIsSFV = currentMilestone === null || currentMilestone === void 0 ? void 0 : currentMilestone.includes('-SFV');
    const SIADTO = getHopeSIADTO(patient, symptomData, currentMilestone, !currentMilestoneIsSFV, !!currentMilestoneIsSFV, '', resolvedVisitId);
    const response = await workflow.saveHopePatientSIA(SIADTO, agency || '', siteId || '');
    return !(response instanceof Response);
  }, [patient, availableHOPEActions, SIAData, appVisit, workflow, agency, siteId]);
  const postSIAData = useCallback(async visit => saveHopePatientSIAForVisit(SIAData, visit === null || visit === void 0 ? void 0 : visit.id), [saveHopePatientSIAForVisit, SIAData]);

  const postSIANote = async (noteText, visit, formInfo) => {
    const {
      firstName,
      lastName,
      userCredentials
    } = currentUser;
    const {
      patientnumber,
      startDate
    } = visit;
    const date = startDate || new Date();
    const patientNumber = patientnumber || (formInfo === null || formInfo === void 0 ? void 0 : formInfo.patientNumber); // append timestamp to SIA note before posting

    const timeStamp = `${firstName} ${lastName}${userCredentials ? `, ${userCredentials}` : ''} ${moment.utc(date).tz(currentUser === null || currentUser === void 0 ? void 0 : currentUser.siteTimezone).format('MM/DD/YYYY hh:mmA')}\n`;
    const formEntity = formInfo ? [{
      entitykey: formInfo.formId,
      entitytypeshortname: 'MFST',
      entityname: formInfo.formName,
      createdatetime: formatPostDate(new Date()),
      createpersonid: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id
    }] : undefined;
    const method = 'POST';
    const ignoreentitydto = 'false';
    const progressNoteData = {
      modifieddatetime: formatPostDate(new Date()),
      modifiedpersonnumber: currentUser.personNumber,
      note: `${noteText}\n- ${timeStamp}`,
      noteddatetime: formatPostDate(new Date()),
      visitdatetime: formatPostDate(date),
      patientnumber: patientNumber,
      personnumber: currentUser.personNumber,
      patientprogressnoteentitydto: formEntity,
      siteid: siteId,
      patientvisit_id: visit === null || visit === void 0 ? void 0 : visit.id,
      isipu: false
    };
    return observation.saveProgressNote(progressNoteData, agency || '', method, ignoreentitydto).then(() => {
      dispatchPNG({
        type: REFRESH_PN_DATA,
        payload: null
      });
    });
  };

  const postHopeSIANote = useCallback(async visit => {
    if (!patient) return false;
    const currentMilestone = getCurrentMilestone(availableHOPEActions);
    const currentMilestoneIsSFV = currentMilestone === null || currentMilestone === void 0 ? void 0 : currentMilestone.includes('-SFV');
    let formInfo;

    if (currentMilestoneIsSFV) {
      formInfo = getHopeFormInfoForVisit(currentMilestone);
    }

    let noteText = SIAText;

    if (!noteText && isSIADataComplete(SIAData) && currentMilestone) {
      noteText = buildHopeSIANoteText(SIAData, currentMilestone, !!currentMilestoneIsSFV);
    }

    if (!noteText) {
      return true;
    }

    try {
      await postSIANote(noteText, visit, formInfo);
      return true;
    } catch {
      return false;
    }
  }, [patient, availableHOPEActions, SIAText, SIAData]);

  const refuseSIAVisit = async (reasonNotDone, summaryData) => {
    if (!patient && !summaryData) return;
    const currentMilestone = getCurrentMilestone(availableHOPEActions);
    const visitMilestone = currentMilestone && (currentMilestone === null || currentMilestone === void 0 ? void 0 : currentMilestone.split('-')[0]);
    const SIADTO = getHopeSIADTO(patient || summaryData, emptySIA, (summaryData === null || summaryData === void 0 ? void 0 : summaryData.milestone) || visitMilestone, false, false, reasonNotDone || '', appVisit && `${appVisit === null || appVisit === void 0 ? void 0 : appVisit.id}` || '');
    const response = await workflow.saveHopePatientSIA(SIADTO, agency || '', siteId || '');

    if (!(response instanceof Response) && reasonNotDone && summaryData) {
      const refusedNote = `Addendum\n\u2022 ${summaryData.milestone} J2052C: Reason SFV was not done. ${reasonNotDone}. ${refusedSIAOptions[reasonNotDone]}`; // TODO any kind of handling... sorry

      const noteResponse = postSIANote(refusedNote, {
        id: summaryData === null || summaryData === void 0 ? void 0 : summaryData.patientvisit_id
      }, {
        formId: summaryData === null || summaryData === void 0 ? void 0 : summaryData.patientmanifest_id,
        formName: summaryData === null || summaryData === void 0 ? void 0 : summaryData.formname,
        patientNumber: summaryData === null || summaryData === void 0 ? void 0 : summaryData.patientNumber
      });
      return true;
    }

    return null;
  };

  const postStatusUpdate = async update => workflow.postHopeStatusUpdate(update, agency || '', siteId || '');
  /**
   * HOPE record-visit API order (awaited): patientsia → statusupdate → hopereport
   * → getvisits → patientprogressnote. closePatientVisit runs only after this returns proceed.
   */


  const runHopeRecordVisitSequence = useCallback(async visit => {
    if (!isHopeEnabled || !isHopeVisit || !canSubmitHopeVisit || !patient) {
      return {
        proceed: true
      };
    }

    const currentMilestone = getCurrentMilestone(availableHOPEActions);
    const currentMilestoneIsSFV = currentMilestone === null || currentMilestone === void 0 ? void 0 : currentMilestone.includes('-SFV');
    await saveHopePatientSIAForVisit(SIAData, visit === null || visit === void 0 ? void 0 : visit.id);
    let hopeStatusUpdateDone = false;
    const reportType = getHopePreSubmitMilestoneType(currentMilestone);

    if (reportType && currentMilestone) {
      var _patient$episodes3, _acceptedHopeAttribut;

      const hopeDTOProp = hopeDocumentProps[reportType] || '';
      const episodeId = `${((patient === null || patient === void 0 ? void 0 : (_patient$episodes3 = patient.episodes) === null || _patient$episodes3 === void 0 ? void 0 : _patient$episodes3.length) || 1) - 1}`;
      const action = (_acceptedHopeAttribut = acceptedHopeAttributes[currentMilestone]) === null || _acceptedHopeAttribut === void 0 ? void 0 : _acceptedHopeAttribut.status;

      if (action) {
        const update = {
          patientid: patient.id,
          episodeid: episodeId,
          visitid: visit === null || visit === void 0 ? void 0 : visit.id,
          milestone: reportType,
          effectiveDateUtc: formatPostDate(visit === null || visit === void 0 ? void 0 : visit.startDate),
          action
        };
        const statusRes = await postStatusUpdate(update);

        if (!(statusRes instanceof Response)) {
          hopeStatusUpdateDone = true;
          const reportRes = await workflow.getHopeReviewItems(`${patient.patientNumber}`, episodeId, reportType, agency || '', siteId || '');

          if (!(reportRes instanceof Response)) {
            const reportRows = Array.isArray(reportRes) ? reportRes : [];
            const blockingErrors = getHopeBlockingErrors(reportRows, hopeDTOProp, !!currentMilestoneIsSFV);

            if (blockingErrors.length > 0) {
              return {
                proceed: false,
                blockingErrors,
                hopeDTOProp,
                hopeStatusUpdateDone: true
              };
            }
          }
        }
      }
    }

    if (currentUser !== null && currentUser !== void 0 && currentUser.personNumber && visit !== null && visit !== void 0 && visit.id) {
      const visitDetails = await getVisitByPersonAndVisitId(currentUser.personNumber, `${visit.id}`, agency || '', keycloak, patient.patientNumber);

      if (visitDetails && !(visitDetails instanceof Response) && visitDetails[0] && globalDispatch) {
        globalDispatch({
          type: SET_APP_VISIT_DETAILS,
          payload: visitDetails[0]
        });
      }
    }

    const notePosted = await postHopeSIANote(visit);

    if (!notePosted) {
      return {
        proceed: false
      };
    }

    return {
      proceed: true,
      hopeStatusUpdateDone
    };
  }, [isHopeEnabled, isHopeVisit, canSubmitHopeVisit, patient, availableHOPEActions, SIAData, agency, siteId, workflow, keycloak, currentUser, completedPatientForms, patientVisitHistory, globalDispatch, saveHopePatientSIAForVisit, postHopeSIANote]); // for use in the visit widget

  const updateHopeVisitStatus = async (patientId, episodeId, milestone, visit) => {
    var _acceptedHopeAttribut2;

    const postMilestone = milestone.split('-')[0];
    const action = (_acceptedHopeAttribut2 = acceptedHopeAttributes[milestone]) === null || _acceptedHopeAttribut2 === void 0 ? void 0 : _acceptedHopeAttribut2.status;
    const update = {
      patientid: patientId,
      episodeid: episodeId,
      visitid: visit === null || visit === void 0 ? void 0 : visit.id,
      milestone: postMilestone,
      effectiveDateUtc: formatPostDate(visit === null || visit === void 0 ? void 0 : visit.startDate),
      action
    };
    postStatusUpdate(update).then(res => {
      resetHopeWorkflow();
      refreshHopeData();
    });
  }; // for addmitting the patient in O&N


  const admitHopePatient = (patientId, episodeId, admissionDate) => {
    const update = {
      patientid: patientId,
      episodeid: episodeId,
      visitid: '',
      milestone: ADM,
      effectiveDateUtc: admissionDate,
      action: Admit
    };
    const response = workflow.postHopeStatusUpdate(update, agency || '', siteId || '');

    if (response instanceof Response) {// todo error handling
    } else {
      refreshHopeData();
    }
  };

  useEffect(() => {
    if (!!appVisit && isHopeEnabled) {
      if ((appVisit === null || appVisit === void 0 ? void 0 : appVisit.careProviderRoleGroup) === Nurse) {
        const visitId = `${appVisit.id}`;

        if (hopeMilestonesLoadedVisitIdRef.current === visitId && availableHOPEActions) {
          return;
        }

        getHopeMilestones();
      }
    }
  }, [appVisit === null || appVisit === void 0 ? void 0 : appVisit.id, patientHopeDetail === null || patientHopeDetail === void 0 ? void 0 : patientHopeDetail.length]);
  useEffect(() => {
    siaFetchedForVisitIdRef.current = null;
    hopeMilestonesLoadedVisitIdRef.current = null;
  }, [appVisit === null || appVisit === void 0 ? void 0 : appVisit.id]);
  useEffect(() => {
    const loadSavedSIA = async () => {
      if (!isHopeEnabled || !isHopeVisit || !(appVisit !== null && appVisit !== void 0 && appVisit.id) || !agency) {
        return;
      }

      const visitId = `${appVisit.id}`;

      if (siaFetchedForVisitIdRef.current === visitId) {
        return;
      }

      siaFetchedForVisitIdRef.current = visitId;
      const existing = await workflow.getHopePatientSIA(visitId, agency, siteId || undefined);

      if (!hopePatientSiaExists(existing)) {
        return;
      }

      const row = Array.isArray(existing) ? existing[0] : existing;
      const siaPayload = extractSIADataFromHopePatientSia(row);

      if (!Object.keys(siaPayload).length) {
        return;
      }

      dispatch({
        type: UPDATE_SIA_DATA,
        payload: siaPayload
      });
    };

    loadSavedSIA();
  }, [isHopeEnabled, isHopeVisit, appVisit === null || appVisit === void 0 ? void 0 : appVisit.id, agency, siteId, workflow]);
  useEffect(() => {
    if (!isHopeVisit || !availableHOPEActions || SIAText) {
      return;
    }

    const currentMilestone = getCurrentMilestone(availableHOPEActions);

    if (!currentMilestone || !isSIADataComplete(SIAData)) {
      return;
    }

    const note = buildHopeSIANoteText(SIAData, currentMilestone, currentMilestone.includes('-SFV'));

    if (note) {
      dispatch({
        type: SET_SIA_TEXT,
        payload: note
      });
    }
  }, [isHopeVisit, availableHOPEActions, SIAData, SIAText]);
  useEffect(() => {
    if (isHopeVisit === null) return;

    if (isHopeVisit && isHopeEnabled) {
      validateVisitData();
    }
  }, [isHopeVisit, hopeVisitAttributesSaved, isOtherInProgHopeVisit, availableHOPEActions, appVisit, appVisitDetails, SIAData && Object.keys(SIAData).length, completedPatientForms.length, inProgressPatientForms.length, refreshVisits]);
  const context = useMemo(() => ({
    globalCrossPatientHopeData,
    patientHopeDetail,
    globalCrossPatientHIS,
    availableHOPEActions,
    availableMilestonesRes,
    isHopeVisit,
    canSubmitHopeVisit,
    SIAData,
    postSIAData,
    refuseSIAVisit,
    resetHopeWorkflow,
    refreshHopeData,
    updateHopeVisitStatus,
    admitHopePatient,
    visitRequiresSFV,
    SIAText,
    displaySIA,
    displayHopeVisitPrompt,
    isOtherInProgHopeVisit,
    hopeVisitAttributesSaved,
    hopeMissingDocumentation,
    hopeMissingSIA,
    hopeValidationPending,
    getAllUsersHopeMilestones,
    runHopeRecordVisitSequence,
    saveHopePatientSIAForVisit,
    postHopeSIANote,
    dispatch
  }), [globalCrossPatientHopeData, patientHopeDetail, globalCrossPatientHIS, availableHOPEActions, availableMilestonesRes, isHopeVisit, canSubmitHopeVisit, SIAData, postSIAData, refuseSIAVisit, resetHopeWorkflow, refreshHopeData, updateHopeVisitStatus, admitHopePatient, visitRequiresSFV, SIAText, displaySIA, displayHopeVisitPrompt, isOtherInProgHopeVisit, hopeVisitAttributesSaved, hopeMissingDocumentation, hopeMissingSIA, hopeValidationPending, getAllUsersHopeMilestones, runHopeRecordVisitSequence, saveHopePatientSIAForVisit, postHopeSIANote, dispatch]);
  return /*#__PURE__*/React.createElement(HopeGlobalContext.Provider, {
    value: context
  }, children);
};
export function withHopeGlobalContext(Component) {
  return function contextComponent(props) {
    return /*#__PURE__*/React.createElement(HopeGlobalContextConsumer, null, context => /*#__PURE__*/React.createElement(HopeGlobalDispatchContextConsumer, null, dispatchContext => /*#__PURE__*/React.createElement(Component, _extends({}, props, context, dispatchContext))));
  };
}
export default HopeGlobalContext;